import { UpperCasePipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core'
import { Store } from '@core/stores'

@Component({
  selector: 'principal-title',
  imports: [UpperCasePipe],
  templateUrl: './principal-title.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrincipalTitleComponent {
  store = inject(Store)

  user = computed(() => this.store.currentUser())
}
